import { ObservableArray, View } from "binder"
import { IfElseGenerator, TemplateSelectorComboBox, TemplateSelectorEditorViewModel } from "./templateSelectorEditor-viewModel"

export class TemplateSelectorEditorView extends View<TemplateSelectorEditorViewModel>{
    GetViewUniqueId(): string {
        return "V-CA00EE01-6265-4919-AA16-50EBD56781B3"
    }
    loadHtml(): string {
        let element = require('./templateSelectorEditor.html').default;
        let style = require('./templateSelectorEditor.less');
        return element;
    }
    constructor() {
       super();
    }
    public set selector(v: TemplateSelectorComboBox) { this._selector = v; } public get selector(): TemplateSelectorComboBox { return this._selector;} private _selector: TemplateSelectorComboBox;
    public set ifElseSelectors(v: ObservableArray<IfElseGenerator>) { this._ifElseSelectors = v; } public get ifElseSelectors(): ObservableArray<IfElseGenerator> { return this._ifElseSelectors;} private _ifElseSelectors: ObservableArray<IfElseGenerator>;
    

    addNew(){
        this.dataContext.addNew();
    }
}
